import { type ReactElement } from 'react';
import { Flex } from '@fastnorth/kraken/components/layout';
import { useApp } from '../../hooks/AppProvider';
import type { ResultEvent } from '../../types/events';
import ResultsByYear from '../../components/results-by-year/ResultsByYear';
import { useTimerProps } from '../../hooks/useTimerProps.ts';
import TimerDetails from '../../components/timer-details/TimerDetails';

const TimingMenuGroup = (): ReactElement | null => {
  const [{ event }] = useApp();

  const { shouldShowTimerDetails, timerProps } = useTimerProps(event as ResultEvent | null);

  if (!event || (!shouldShowTimerDetails && !event.relatedEvents?.length)) {
    return null;
  }

  return (
    <Flex className={'flex-col gap-6'}>
      {timerProps && <TimerDetails timingProvider={timerProps.timingProvider} />}
      <ResultsByYear />
    </Flex>
  );
};

export default TimingMenuGroup;
